module.exports = __webpack_public_path__ + "coin_ZAR.svg?22c322317584fc761c430dd34cddb912";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_ZAR.svg
// module id = 1135
// module chunks = 2